import Chart from 'chart.js/auto'
import {TreemapController, TreemapElement} from 'chartjs-chart-treemap';
import _ from 'lodash';

import PieChartOAShare from './PieChartOAShare';
import StackedBarChartOAType from './StackedBarChartOAType';
import StackedBarChartPublishers from './StackedBarChartPublishers';
import StackedBarChartTopics from './StackedBarChartTopics';
import TreeMapApcCosts from './TreeMapApcCosts';

Chart.register(TreemapController, TreemapElement);

const files = [
  '../data/publications_2021_oa_aggregation.json',
  '../data/publications_2021_oa_publisher_aggregation.json',
  '../data/publications_2021_oa_topic_aggregation.json',
  '../data/publications_2021_oa_total_aggregation.json',
  '../data/publications_2022_oa_aggregation.json',
  '../data/publications_2022_oa_publisher_aggregation.json',
  '../data/publications_2022_oa_topic_aggregation.json',
  '../data/publications_2022_oa_total_aggregation.json',
  '../data/publications_2022_openapc.json',
  '../data/publications_2023_oa_aggregation.json',
  '../data/publications_2023_oa_publisher_aggregation.json',
  '../data/publications_2023_oa_topic_aggregation.json',
  '../data/publications_2023_oa_total_aggregation.json',
  '../data/publications_2023_openapc.json',
  '../data/publications_2024_oa_aggregation.json',
  '../data/publications_2024_oa_publisher_aggregation.json',
  '../data/publications_2024_oa_topic_aggregation.json',
  '../data/publications_2024_oa_total_aggregation.json',
  '../data/publications_2025_oa_aggregation.json',
  '../data/publications_2025_oa_publisher_aggregation.json',
  '../data/publications_2025_oa_topic_aggregation.json',
  '../data/publications_2025_oa_total_aggregation.json'
];

let jsonCombined = {};

// Read JSON files and merge contents into one object
async function readJsonFiles() {
    for (const filePath of files) {
      try {
          const response = await fetch(filePath);
          if (!response.ok) {
              throw new Error('Network response was not ok ' + response.statusText);
          }
          const jsonData = await response.json();
          _.merge(jsonCombined, jsonData);
      } catch (error) {
          console.error('Error reading JSON file:', error);
      }
    }
    initDashboard();
}

function initDashboard() {

  // Remove all loaders elements
  const loaders = document.querySelectorAll(".loader");
  loaders.forEach(loader => {
    loader.remove();
  });

  // Display charts
  const charts = document.querySelectorAll(".chart");
  charts.forEach(chart => {
    chart.style.display = "block";
  });
  
  new PieChartOAShare(
    'publications-oa-total-2021',
    jsonCombined['publications']['2021']['oa_total_aggregation']
  );

  new PieChartOAShare(
    'publications-oa-total-2022',
    jsonCombined['publications']['2022']['oa_total_aggregation']
  );

  new PieChartOAShare(
    'publications-oa-total-2023',
    jsonCombined['publications']['2023']['oa_total_aggregation']
  );

  new PieChartOAShare(
    'publications-oa-total-2024',
    jsonCombined['publications']['2024']['oa_total_aggregation']
  );

  new PieChartOAShare(
    'publications-oa-total-2025',
    jsonCombined['publications']['2025']['oa_total_aggregation']
  );

  new StackedBarChartOAType(
    'publications-by-type',
    jsonCombined['publications']
  );

  new TreeMapApcCosts(
    'costs-of-gold-publications',
    jsonCombined['publications']
  );

  new StackedBarChartPublishers(
    'publications-by-publisher',
    jsonCombined['publications']
  );

  // Display all canvas elements
  const canvas = document.querySelectorAll("canvas");
  canvas.forEach(canvas => {
    canvas.style.display = "block";
  });

  addAboutButtonListeners();
};

function addAboutButtonListeners() {
  const aboutBtns = document.querySelectorAll(".about-btn");
  const overlayWrapper = document.createElement("div");

  for (const aboutBtn of aboutBtns) {
    aboutBtn.addEventListener('click', (event) => {
      event.preventDefault();

      const iframeWrapper = document.createElement("div");
      iframeWrapper.className = "overlay-wrapper";
      iframeWrapper.style.height = document.body.scrollHeight + "px";

      const iframe = document.createElement("iframe");
      iframe.src = `${window.location.pathname}/about.html`;
      iframe.className = "overlay";

      iframeWrapper.appendChild(iframe);
      document.body.appendChild(iframeWrapper);

      iframeWrapper.addEventListener("click", function() {
        document.body.removeChild(iframeWrapper);
      });
    })
  }
}

readJsonFiles();
